var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1102 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: url(#linear-gradient);\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: .65px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n        filter: url(#outer-glow-1);\n        stroke-width: 0px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 695.37,
    y1: -175.16,
    x2: 405.73,
    y2: 326.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5182e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cc1f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b53248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f5267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a7e92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#17b6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 13.55,
    y1: 79.55,
    x2: 1087.55,
    y2: 79.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 4.52
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#46d2e0",
    floodOpacity: 0.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1052.01,120.2H49.1c-4.37-4.37-6.82-6.82-11.19-11.19V42.33c4.37-4.37,6.82-6.82,11.19-11.19h1002.91c4.37,4.37,6.82,6.82,11.19,11.19v66.67c-4.37,4.37-6.82,6.82-11.19,11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1084.55,84.04l3-2.45v12.54l-3,2.45v-12.54ZM44.74,142.55l-28.18-23.01V39.15l28.18-23.01h122.56l-3-2.45H43.49l-29.94,24.44v82.42l29.94,24.44h369.8l-3-2.45H44.74ZM1084.55,119.54l-28.18,23.01h-111.62l2.2,2.45h110.67l29.94-24.44v-13.09l-3,2.45v9.63ZM1057.61,13.69h-293.22l2.2,2.45h289.78l28.18,23.01v5.7l3-2.45v-4.27l-29.94-24.44ZM1084.55,70.72l3-2.45v-12.54l-3,2.45v12.54ZM678.99,14.49H251.24v.82h427.74v-.82ZM465.12,145.41h427.74v-.82h-427.74v.82Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.8138d5a04821548ee2c68e4d2df92336.svg";
export { ForwardRef as ReactComponent };